import { Group, Text } from "@mantine/core"
import { tokens } from "../../config/tokens"
import BackedTokenAmount from "./BackedTokenAmount"
import { Asset } from '@greymass/eosio';
import _ from 'lodash'

export default function BackingDescription({backedby, redeem_url}) {

    if ( ! backedby ) { return <></> }
    const asset = Asset.from(backedby)
    const token = _.find(tokens,{symbol: asset.symbol.code.toString()})

    const t = {
        amount: backedby.split(' ')[0],
        token_contract: token.contract,
        token_symbol: token.symbol,
        token_precision: token.precision,
    }

    return (
        <>
            <Group>
                <Text size='sm'>This NFT is securely backed by NFT Backers with:</Text>
                <BackedTokenAmount key={t.token_symbol} backed_token={t} />
            </Group>
            {
                redeem_url ?
                <Text mt='md' size='sm'>
                    The asset(s) backing this token can be extracted by burning the NFT.
                    However, as the specific backing may require one or more additional steps before
                    taking physical delivery, we recommend redeeming this NFT with the author
                    using the following link: <a href={redeem_url}>{redeem_url}</a>
                </Text>
                : <Text mt='md' size='sm'>
                    The asset(s) backing this token can be extracted by burning the NFT.
                    However, as the specific backing may require one or more additional steps before
                    taking physical delivery, we recommend checking with the collection author for
                    specific redemption instructions.
                </Text>
            }
        </>
    )
}


